/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import "./style.css";
import React, { useState, useEffect } from "react";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import VerifiedIcon from "@mui/icons-material/VerifiedOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DiscountIcon from "@mui/icons-material/Discount";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import Footer from "../../Components/Footer";
import ScrollToTop from "../../Components/scrollup";
import UseFetch from "../../hook/useFetch";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Button } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import BestBroduct from "../../Components/ProductRandom";
import ProductBrand from "../../Components/ProductBrand";
import { Dialog, Box } from "@mui/material";
import Rating from "@mui/material/Rating";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import parse from "html-react-parser";
export default function ProductDetails() {
  const { data, loading } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );
  const [userRating, setUserRating] = useState(0);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbarer, setOpenSnackbarer] = useState(false);
  const produits = Array.from(data);
  const [openRate, setOpenRate] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [openDialog3, setOpenDialog3] = useState(false);
  const user = localStorage.getItem("log");
  const username = localStorage.getItem("name");
  const [couleurSelectionnee, setCouleurSelectionnee] = useState(null);

  const handleClickCouleur = (color) => {
    // Mettre à jour l'état avec la couleur sélectionnée
    setCouleurSelectionnee(color);
  };
  const handleOpenRate = () => {
    setOpenRate(true);
  };
  const handleCloseRate = () => {
    setOpenRate(false);
  };
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleOpenDialog2 = () => {
    setOpenDialog2(true);
  };
  const handleOpenDialog3 = () => {
    setOpenDialog3(true);
  };
  // Fonction pour fermer la boîte de dialogue
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
  };
  const handleCloseDialog3 = () => {
    setOpenDialog3(false);
  };
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg")); // Vérifie si l'écran est de taille large (lg et supérieur)
  const buttonSize = isLargeScreen ? "medium" : "small";
  const [display, setDisplay] = useState(false);
  function displayDescreption() {
    setDisplay(display === false ? true : false);
  }
  let pathName = window.location.pathname;
let pathe = pathName.replace(/%20/g, " ");
let path1 = pathe.split("/")[2]; // famille
let path2 = pathe.split("/")[3]; // catégorie
let path3 = pathe.split("/")[4]; // sous-catégorie
let path4 = pathe.split("/")[5]; // sub-sous-catégorie
let path5 = pathe.split("/")[6]; // article (ou subSubcategorie)

// état pour snackbar
const [open, setOpen] = React.useState(false);

// Ajout au panier
const addToCart = () => {
  // Chercher le produit selon le niveau le plus profond
  const productIndex = produits.findIndex((produit) => {
    if (path5) return produit.articleName === path5;
    if (path4) return produit.articleName === path4;
    return produit.articleName === path3;
  });

  if (productIndex !== -1) {
    const product = produits[productIndex];

    // Panier existant ou nouveau
    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];

    const existingProductIndex = existingCart.findIndex((item) => {
      if (path5) return item.articleName === path5;
      if (path4) return item.articleName === path4;
      return item.articleName === path3;
    });

    if (existingProductIndex !== -1) {
      existingCart[existingProductIndex].quantite += 1;
    } else {
      const price = product.prixPromo
        ? product.prixPromo
        : product.prixFlash
        ? product.prixFlash
        : product.prix;

      existingCart.push({
        family: product.famille,
        name: product.articleName,
        img: `${path2} ${path3}`,
        categorie: product.categorie,
        souscategorie: product.subcategorie,
        subSubcategorie: product.subSubcategorie || "", // <-- ajouté
        price: price.toFixed(3),
        brand: product.brand,
        reference: product.ref,
        quantite: 1,
        color: couleurSelectionnee,
      });
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    handleClick();
    window.location.reload();
  }
};

const handleClick = () => setOpen(true);
const handleClose = () => setOpen(false);

// Produit courant selon path5 > path4 > path3
const currentProduct = produits.find((produit) => {
  if (path5) return produit.articleName === path5;
  if (path4) return produit.articleName === path4;
  return produit.articleName === path3;
});



  return (
    <div className="products details" id="produits">
      <div className="productDetails">
        <span className="navbarCollection details">
          collections
          {path1 && <a href={`/collections/${path1}`}>{` / ${decodeURIComponent(path1)}`} </a>}
          {path2 && (
            <a href={`/collections/${path1}/${path2}`}>
              {` / ${decodeURIComponent(path2)}`}{" "}
            </a>
          )}
          {path3 && (
            <a href={`/collections/${path1}/${path2}/${path3}`}>
              {` / ${decodeURIComponent(path3)}`}{" "}
            </a>
          )}
          {path4 && (
            <a href={`/collections/${path1}/${path2}/${path3}/${path4}`}>
              {` / ${decodeURIComponent(path4)}`}{" "}
            </a>
          )}
           {path5 && (
            <a href={`/produit/${path1}/${path2}/${path3}/${path4}/${path5}`}>
              {` / ${decodeURIComponent(path5)}`}{" "}
            </a>
          )}
        </span>
        <ScrollToTop />
        {loading ? (
          <div className="loader details"></div>
        ) : (
          <div className="productContainDetail">
            <h2 className="pathTitle" key={Math.floor(Math.random() * 1)}>
              {path5 ? decodeURIComponent(path5) :path4 ? decodeURIComponent(path4) : decodeURIComponent(path3)}
            </h2>
            <div>
              {produits.map((produit, index) =>
                produit.articleName === decodeURIComponent(path3) ? (
                  <div className="productcardDetails" key={index}>
                    <Carousel
                      showArrows={false}
                      autoPlay={false}
                      showIndicators={false}
                      showStatus={false}
                      className="custom-carousel"
                    >
                      <div onClick={() => handleOpenDialog()}>
                        <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(
                            path1
                          )}%2F${decodeURIComponent(
                            path2
                          )}%2F${decodeURIComponent(
                            path2
                          )}%20${decodeURIComponent(path3)}.jpeg?alt=media`}
                          title={path3}
                          alt={path3}
                        />
                      </div>
                      <div onClick={() => handleOpenDialog2()}>
                        <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(
                            path1
                          )}%2F${decodeURIComponent(
                            path2
                          )}%2F${decodeURIComponent(
                            path2
                          )}%20${decodeURIComponent(path3)}-1.jpeg?alt=media`}
                          title={path3}
                          alt={path3}
                        />
                      </div>
                      {produit.photoPlus ? (
                        <div onClick={() => handleOpenDialog3()}>
                          <img
                            className="cardDetails"
                            src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(
                              path1
                            )}%2F${decodeURIComponent(
                              path2
                            )}%2F${decodeURIComponent(
                              path2
                            )}%20${decodeURIComponent(path3)}-2.jpeg?alt=media`}
                            title={path3}
                            alt={path3}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </Carousel>
                    <Dialog
                      open={openDialog}
                      onClose={handleCloseDialog}
                      sx={{ zIndex: 9999999 }}
                    >
                      <img
                        src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(
                          path1
                        )}%2F${decodeURIComponent(
                          path2
                        )}%2F${decodeURIComponent(
                          path2
                        )}%20${decodeURIComponent(path3)}.jpeg?alt=media`}
                        alt={path3}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "80vh",
                          objectFit: "contain",
                          zIndex: 9999999,
                        }}
                      />
                    </Dialog>
                    <Dialog
                      open={openDialog2}
                      onClose={handleCloseDialog2}
                      sx={{ zIndex: 9999999 }}
                    >
                      <img
                        src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(
                          path1
                        )}%2F${decodeURIComponent(
                          path2
                        )}%2F${decodeURIComponent(
                          path2
                        )}%20${decodeURIComponent(path3)}-1.jpeg?alt=media`}
                        alt={path3}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "80vh",
                          objectFit: "contain",
                          zIndex: 9999999,
                        }}
                      />
                    </Dialog>
                    {produit.photoPlus ? (
                      <Dialog
                        open={openDialog3}
                        onClose={handleCloseDialog3}
                        sx={{ zIndex: 9999999 }}
                      >
                        <img
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(
                            path1
                          )}%2F${decodeURIComponent(
                            path2
                          )}%2F${decodeURIComponent(
                            path2
                          )}%20${decodeURIComponent(path3)}-2.jpeg?alt=media`}
                          alt={path3}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "80vh",
                            objectFit: "contain",
                            zIndex: 9999999,
                          }}
                        />
                      </Dialog>
                    ) : (
                      <></>
                    )}
                    
                    <div className="morecardDetailP">
                      <h2>
                        {produit.articleName} - <a style={{textDecoration:'none' , color:'#F77171'}} href={`/${produit.brand}`}> {produit.brand} </a>{produit.ref}
                      </h2>
                    {produit.prixFlash ? (
                        <>
                          <h4
                            style={{
                              textDecoration: "line-through",
                              textDecorationColor: "red",
                              textDecorationThickness: "2px",
                              color: "black",
                            }}
                          >
                            {produit.prix.toFixed(0)} TND
                          </h4>
                          <h4 style={{ marginTop: "-10px" }}>
                            {produit.prixFlash.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      ) : produit.prixPromo ? (
                        <>
                        
                          <h4
                            style={{
                              textDecoration: "line-through",
                              textDecorationColor: "brown",
                              textDecorationThickness: "2px",
                              color: "black",
                            }}
                          >
                            {produit.prix.toFixed(0)} TND
                        
                          </h4>
                         
                          <h4 style={{ marginTop: "-10px" }}>
                            {produit.prixPromo.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      ) : (
                        <>
                          <h4>
                            {produit.prix.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      )}
                      {produit.colors?(
                        <>
                     {produit.colors && produit.colors.length > 0 ? (
    <span className="morecardDetailColor">Sélectionnez la texture de votre mobilier</span>
) : (
    <></>
)}
      <div className="colorboisDiv">
        {produit.colors.map((color, index) => (
          
          <img
            key={index}
            src={require(`../../images/colors/${color}.jpeg`)} // Utilisation de .default pour charger l'image
            alt={color}
            className={`boisColor ${color === couleurSelectionnee ? 'selected' : ''}`}
            onClick={() => handleClickCouleur(color)}
          />
        ))}
      </div></>):(<></>)}
              
                      <Button
                        sx={{
                          marginTop: 5,
                          fontFamily: "Exo",
                          fontSize: {
                            lg: "14px",
                            md: "12px",
                            sm: "12px",
                            xs: "10px",
                          },
                        }}
                        onClick={displayDescreption}
                        variant="contained"
                        size={buttonSize}
                        color="warning"
                        fullWidth
                        endIcon={<VisibilityIcon />}
                      >
                        Voir le descriptif technique
                      </Button>
                      {display ? (
                        <p>
                          {parse(produit.descreption)}
                          <br />
                          {produit.categorie !== "meubles" ? (
                            <strong> garantie: 1 ans</strong>
                          ) : (
                            <></>
                          )}
                        </p>
                      ) : (
                        <></>
                      )}
                      {produit.stock < 1 ? (
                        <Button
                          sx={{
                            marginTop: 5,
                            fontFamily: "Exo",
                            fontSize: {
                              lg: "14px",
                              md: "12px",
                              sm: "12px",
                              xs: "10px",
                            },
                          }}
                          variant="contained"
                          color="warning"
                          size={buttonSize}
                          fullWidth
                          endIcon={<LocalShippingIcon />}
                        >
                          EN ARRIVAGE
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            marginTop: 5,
                            fontFamily: "Exo",
                            fontSize: {
                              lg: "14px",
                              md: "12px",
                              sm: "12px",
                              xs: "10px",
                            },
                          }}
                          variant="contained"
                          color="warning"
                          size={buttonSize}
                          fullWidth
                          startIcon={<ShoppingCartIcon />}
                          titleAccess={`Ajouter ${produit.articleName} au panier`}
                          onClick={addToCart}
                        >
                          J'achète
                        </Button>
                      )}
                      <div className="profitDetail">
                     {/*    <span className="profitDetailspan">Profitez!</span>
                          <Box sx={{ display: "flex", marginTop: "10px" }}>
                       <DiscountIcon fontSize="small" color="warning" />
                          <span
                            className="profitDetailspan"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            Nouveaux clients? : profitez de 5% de remise avec le
                            code{" "}
                            <span style={{ color: "#F77171", fontWeight: 800 }}>
                              HELLO-5
                            </span>{" "}
                          </span>
                        </Box>*/}
                        <Box sx={{ display: "flex", marginTop: "10px" }}>
                          <PermContactCalendarIcon
                            fontSize="small"
                            color="warning"
                          />
                          <span
                            className="profitDetailspan"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            Pour plus d'informations! : appelez{" "}
                            <a
                              href="tel:26380004"
                              className="profitDetailspan info"
                            >
                              26 380 004{" "}
                            </a>{" "}
                          </span>
                        </Box>
                      </div>
                      <Snackbar
                        open={open}
                        autoHideDuration={5000}
                        onClose={handleClose}
                      >
                        <Alert
                          onClose={handleClose}
                          severity="success"
                          variant="filled"
                          sx={{ width: "100%" }}
                        >
                          {produit.articleName} a été ajouté au panier !
                        </Alert>
                      </Snackbar>
                    </div>
                    {/*--------------------------------------------------------*/}
                  </div>
                ) : produit.articleName === decodeURIComponent(path4) ? (
                  <div className="productcardDetails" key={index}>
                    <Carousel
                      showArrows={false}
                      autoPlay={false}
                      showIndicators={false}
                      showStatus={false}
                      className="custom-carousel"
                    >
                      <div onClick={() => handleOpenDialog()}>
                        <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path3)}%20${decodeURIComponent(path4)}.jpeg?alt=media`}
                          title={path4}
                          alt={path4}
                        />
                      </div>
                      <div onClick={() => handleOpenDialog2()}>
                        <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path3)}%20${decodeURIComponent(path4)}-1.jpeg?alt=media`}
                          title={path4}
                          alt={path4}
                        />
                      </div>
                      {produit.photoPlus ? (
                    
                        <div onClick={() => handleOpenDialog3()}>
                         <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path3)}%20${decodeURIComponent(path4)}-2.jpeg?alt=media`}
                          title={path4}
                          alt={path4}
                        />
                        </div>
                      ) : (
                        <></>
                      )}
                    </Carousel>
                    <Dialog
                      open={openDialog}
                      onClose={handleCloseDialog}
                      sx={{ zIndex: 999999999999999999999999 }}
                    >
                      <img
                      className="cardDetails"
                      src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path3)}%20${decodeURIComponent(path4)}.jpeg?alt=media`}
                      title={path4}
                      alt={path4}

                        style={{
                          maxWidth: "100%",
                          maxHeight: "70vh",
                          objectFit: "contain",
                          zIndex: 9999999999999999999999999999999999999999999,
                        }}
                      />
                    </Dialog>
                    <Dialog
                      open={openDialog2}
                      onClose={handleCloseDialog2}
                      sx={{ zIndex: 9999999 }}
                    >
                      <img
                         src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path3)}%20${decodeURIComponent(path4)}-1.jpeg?alt=media`}
                        alt={path3}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "70vh",
                          objectFit: "contain",
                          zIndex: 9999999,
                        }}
                      />
                    </Dialog>
                    {produit.photoPlus ? (
                      <Dialog
                        open={openDialog3}
                        onClose={handleCloseDialog3}
                        sx={{ zIndex: 9999999 }}
                      >
                        <img
                           src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path3)}%20${decodeURIComponent(path4)}-2.jpeg?alt=media`}
                          alt={path3}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "70vh",
                            objectFit: "contain",
                            zIndex: 9999999,
                          }}
                        />
                      </Dialog>
                    ) : (
                      <></>
                    )}
                    <div className="morecardDetailP">
                      <h2>
                        {produit.articleName} -<a style={{textDecoration:'none' , color:'#F77171'}} href={`/${produit.brand}`}> {produit.brand}</a> {produit.ref}
                      </h2>
                    { produit.prixFlash ? (
                        <>
                          <h4
                            style={{
                              textDecoration: "line-through",
                              textDecorationColor: "red",
                              textDecorationThickness: "2px",
                              color: "black",
                            }}
                          >
                            {produit.prixFlash.toFixed(0)} TND
                          </h4>
                          <h4 style={{ marginTop: "-10px" }}>
                            {produit.prix.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      ) : (
                        <>
                          <h4>
                            {produit.prix.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      )}
                     
                      <Button
                        sx={{
                          marginTop: 5,
                          fontFamily: "Exo",
                          fontSize: {
                            lg: "14px",
                            md: "12px",
                            sm: "12px",
                            xs: "10px",
                          },
                        }}
                        onClick={displayDescreption}
                        variant="contained"
                        size={buttonSize}
                        color="warning"
                        fullWidth
                        endIcon={<VisibilityIcon />}
                      >
                        Voir le descriptif technique
                      </Button>
                      {display ? (
                        <p>
                          {parse(produit.descreption)}
                          <br />
                          {produit.categorie !== "meubles" ? (
                            <strong> garantie: 1 ans</strong>
                          ) : (
                            <></>
                          )}
                        </p>
                      ) : (
                        <></>
                      )}
                      {produit.stock < 1 ? (
                        <Button
                          sx={{
                            marginTop: 5,
                            fontFamily: "Exo",
                            fontSize: {
                              lg: "14px",
                              md: "12px",
                              sm: "12px",
                              xs: "10px",
                            },
                          }}
                          variant="contained"
                          color="warning"
                          size={buttonSize}
                          fullWidth
                          endIcon={<LocalShippingIcon />}
                        >
                          EN ARRIVAGE
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            marginTop: 5,
                            fontFamily: "Exo",
                            fontSize: {
                              lg: "14px",
                              md: "12px",
                              sm: "12px",
                              xs: "10px",
                            },
                          }}
                          variant="contained"
                          color="warning"
                          size={buttonSize}
                          fullWidth
                          startIcon={<ShoppingCartIcon />}
                          titleAccess={`Ajouter ${produit.articleName} au panier`}
                          onClick={addToCart}
                        >
                          J'achète
                        </Button>
                      )}
                      <div className="profitDetail">
                     {/*   <span className="profitDetailspan">Profitez!</span>
                        <Box sx={{ display: "flex", marginTop: "10px" }}>
                          <DiscountIcon fontSize="small" color="warning" />
                          <span
                            className="profitDetailspan"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            Nouveaux clients? : profitez de 5% de remise avec le
                            code{" "}
                            <span style={{ color: "#F77171", fontWeight: 800 }}>
                              HELLO-5
                            </span>{" "}
                          </span>
                        </Box>*/}
                        <Box sx={{ display: "flex", marginTop: "10px" }}>
                          <PermContactCalendarIcon
                            fontSize="small"
                            color="warning"
                          />
                          <span
                            className="profitDetailspan"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            Pour plus d'informations! : appelez{" "}
                            <a
                              href="tel:26380004"
                              className="profitDetailspan info"
                            >
                              26 380 004{" "}
                            </a>{" "}
                          </span>
                        </Box>
                      </div>
                      <Snackbar
                        open={open}
                        autoHideDuration={5000}
                        onClose={handleClose}
                      >
                        <Alert
                          onClose={handleClose}
                          severity="success"
                          variant="filled"
                          sx={{ width: "100%" }}
                        >
                          {produit.articleName} a été ajouté au panier !
                        </Alert>
                      </Snackbar>
                    </div>
                  </div>
                ) : 
                 produit.articleName === decodeURIComponent(path5) ? (
                  <div className="productcardDetails" key={index}>
                    <Carousel
                      showArrows={false}
                      autoPlay={false}
                      showIndicators={false}
                      showStatus={false}
                      className="custom-carousel"
                    >
                      <div onClick={() => handleOpenDialog()}>
                        <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path4)}%2F${decodeURIComponent(path4)}%20${decodeURIComponent(path5)}.jpeg?alt=media`}
                          title={path5}
                          alt={path5}
                        />
                      </div>
                      <div onClick={() => handleOpenDialog2()}>
                        <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path4)}%2F${decodeURIComponent(path4)}%20${decodeURIComponent(path5)}-1.jpeg?alt=media`}
                          title={path5}
                          alt={path5}
                        />
                      </div>
                      {produit.photoPlus ? (
                    
                        <div onClick={() => handleOpenDialog3()}>
                         <img
                          className="cardDetails"
                          src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path4)}%2F${decodeURIComponent(path4)}%20${decodeURIComponent(path5)}-2.jpeg?alt=media`}
                          title={path5}
                          alt={path5}
                        />
                        </div>
                      ) : (
                        <></>
                      )}
                    </Carousel>
                    <Dialog
                      open={openDialog}
                      onClose={handleCloseDialog}
                      sx={{ zIndex: 999999999999999999999999 }}
                    >
                      <img
                      className="cardDetails"
                      src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path4)}%2F${decodeURIComponent(path4)}%20${decodeURIComponent(path5)}.jpeg?alt=media`}
                      title={path4}
                      alt={path4}

                        style={{
                          maxWidth: "100%",
                          maxHeight: "70vh",
                          objectFit: "contain",
                          zIndex: 9999999999999999999999999999999999999999999,
                        }}
                      />
                    </Dialog>
                    <Dialog
                      open={openDialog2}
                      onClose={handleCloseDialog2}
                      sx={{ zIndex: 9999999 }}
                    >
                      <img
                         src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path4)}%2F${decodeURIComponent(path4)}%20${decodeURIComponent(path5)}-1.jpeg?alt=media`}
                        alt={path3}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "70vh",
                          objectFit: "contain",
                          zIndex: 9999999,
                        }}
                      />
                    </Dialog>
                    {produit.photoPlus ? (
                      <Dialog
                        open={openDialog3}
                        onClose={handleCloseDialog3}
                        sx={{ zIndex: 9999999 }}
                      >
                        <img
                           src={`https://firebasestorage.googleapis.com/v0/b/ebuy-10d2e.appspot.com/o/${decodeURIComponent(path1)}%2F${decodeURIComponent(path2)}%2F${decodeURIComponent(path3)}%2F${decodeURIComponent(path4)}%2F${decodeURIComponent(path4)}%20${decodeURIComponent(path5)}-2.jpeg?alt=media`}
                          alt={path3}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "70vh",
                            objectFit: "contain",
                            zIndex: 9999999,
                          }}
                        />
                      </Dialog>
                    ) : (
                      <></>
                    )}
                    <div className="morecardDetailP">
                      <h2>
                        {produit.articleName} -<a style={{textDecoration:'none' , color:'#F77171'}} href={`/${produit.brand}`}> {produit.brand}</a> {produit.ref}
                      </h2>
                    { produit.prixFlash ? (
                        <>
                          <h4
                            style={{
                              textDecoration: "line-through",
                              textDecorationColor: "red",
                              textDecorationThickness: "2px",
                              color: "black",
                            }}
                          >
                            {produit.prixFlash.toFixed(0)} TND
                          </h4>
                          <h4 style={{ marginTop: "-10px" }}>
                            {produit.prix.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      ) : (
                        <>
                          <h4>
                            {produit.prix.toFixed(0)} TND <br />
                            <span className="morecardDetailPrice">
                              {" "}
                              + frais de livraison 8 TND sur toute La Tunisie{" "}
                            </span>
                          </h4>
                        </>
                      )}
                     
                      <Button
                        sx={{
                          marginTop: 5,
                          fontFamily: "Exo",
                          fontSize: {
                            lg: "14px",
                            md: "12px",
                            sm: "12px",
                            xs: "10px",
                          },
                        }}
                        onClick={displayDescreption}
                        variant="contained"
                        size={buttonSize}
                        color="warning"
                        fullWidth
                        endIcon={<VisibilityIcon />}
                      >
                        Voir le descriptif technique
                      </Button>
                      {display ? (
                        <p>
                          {parse(produit.descreption)}
                          <br />
                          {produit.categorie !== "meubles" ? (
                            <strong> garantie: 1 ans</strong>
                          ) : (
                            <></>
                          )}
                        </p>
                      ) : (
                        <></>
                      )}
                      {produit.stock < 1 ? (
                        <Button
                          sx={{
                            marginTop: 5,
                            fontFamily: "Exo",
                            fontSize: {
                              lg: "14px",
                              md: "12px",
                              sm: "12px",
                              xs: "10px",
                            },
                          }}
                          variant="contained"
                          color="warning"
                          size={buttonSize}
                          fullWidth
                          endIcon={<LocalShippingIcon />}
                        >
                          EN ARRIVAGE
                        </Button>
                      ) : (
                        <Button
                          sx={{
                            marginTop: 5,
                            fontFamily: "Exo",
                            fontSize: {
                              lg: "14px",
                              md: "12px",
                              sm: "12px",
                              xs: "10px",
                            },
                          }}
                          variant="contained"
                          color="warning"
                          size={buttonSize}
                          fullWidth
                          startIcon={<ShoppingCartIcon />}
                          titleAccess={`Ajouter ${produit.articleName} au panier`}
                          onClick={addToCart}
                        >
                          J'achète
                        </Button>
                      )}
                      <div className="profitDetail">
                     {/*   <span className="profitDetailspan">Profitez!</span>
                        <Box sx={{ display: "flex", marginTop: "10px" }}>
                          <DiscountIcon fontSize="small" color="warning" />
                          <span
                            className="profitDetailspan"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            Nouveaux clients? : profitez de 5% de remise avec le
                            code{" "}
                            <span style={{ color: "#F77171", fontWeight: 800 }}>
                              HELLO-5
                            </span>{" "}
                          </span>
                        </Box>*/}
                        <Box sx={{ display: "flex", marginTop: "10px" }}>
                          <PermContactCalendarIcon
                            fontSize="small"
                            color="warning"
                          />
                          <span
                            className="profitDetailspan"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            Pour plus d'informations! : appelez{" "}
                            <a
                              href="tel:26380004"
                              className="profitDetailspan info"
                            >
                              26 380 004{" "}
                            </a>{" "}
                          </span>
                        </Box>
                      </div>
                      <Snackbar
                        open={open}
                        autoHideDuration={5000}
                        onClose={handleClose}
                      >
                        <Alert
                          onClose={handleClose}
                          severity="success"
                          variant="filled"
                          sx={{ width: "100%" }}
                        >
                          {produit.articleName} a été ajouté au panier !
                        </Alert>
                      </Snackbar>
                    </div>
                  </div>
                ) :(
                  <></>
                )
              )}
              {/*--------------------------------------------------------*/}
            </div>
          </div>
        )}
      </div>
      <div className="bestProductDiv">
        <h2>Notre sélection pour vous </h2>
        <BestBroduct categName={decodeURIComponent(path2)} currentProduct={decodeURIComponent(path3)} />
        <h2>
          autres produits de la marque{" "}
          <span style={{ color: "#F77171" }}>
            {currentProduct ? currentProduct.brand : null}
          </span>{" "}
        </h2>
        <ProductBrand
          currentProduct={path3}
          brand={currentProduct ? currentProduct.brand : null}
        />
      </div>
      <Footer />
    </div>
  );
}
